import React from 'react';
import './Page.css';

function OurCulture() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Our Culture</h1>
        </div>
        
        <div className="culture-item">
          <h2>Doing the right thing</h2>
          <p>
            This pervades everything we do. In our dealings with potential and existing clients, regulators, service providers, team members 
            and companies, we are governed by a strong moral compass about what the right thing to do is, not just what is legally permissible.
          </p>
        </div>

        <div className="culture-item">
          <h2>Respect for each other, our shared goals, and guiding principles</h2>
          <p>
            We deeply respect each other. We also share a deep respect for our shared vision and guiding principles, which have brought us 
            together to build the firm. These shared beliefs and mutual respect form the foundation of our partnership. We believe in a 
            non-hierarchical and collaborative team culture, where everyone's voice is heard and valued. We have been influenced by the 
            McKinsey team environment, where dissent is encouraged and different perspectives are welcomed.
          </p>
        </div>

        <div className="culture-item">
          <h2>Continuous learning and improvement</h2>
          <p>
            A key part of the attraction of the investing profession to us is that it is a lifelong school. We are thankful for the opportunity 
            to learn about industries and businesses every day. We are inquisitive and curious by nature and investment research plays to these 
            traits. We read and listen widely to learn as much as we can. We regularly question our assumptions and hypotheses, especially in the 
            face of new facts, and this usually leads to deeper understanding and newer insights. We believe that investment excellence is a journey, 
            not a destination. As craftsmen, it is important for us to continuously evaluate our tools and see how we might sharpen them.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OurCulture;
